import "./style.css";

export default class TechnologyNavigatorResults {
  static selector = ".technology-navigator-results";

  constructor(block) {
    this.block = block;
    this.items = [];
  }

  handleItemOpen = (e) => {
    const item = e.currentTarget;
    const title = item.querySelector(
      ".technology-navigator-results__item-title"
    );
    const url = title.dataset.url;

    if (url) {
      window.App.fakeNavigateTo(url);
    }
  };

  onReady = () => {
    this.items = Array.from(this.block.querySelectorAll(".accordion__item"));
    this.items.forEach((item) => {
      item.addEventListener("accordion:item:open", this.handleItemOpen);
    });
  };

  onDestroy = () => {
    this.items.forEach((item) => {
      item.removeEventListener("accordion:item:open", this.handleItemOpen);
    });
  };
}
